import { makeStyles } from "@mui/styles";
import {alpha} from "@mui/material";

const useStyles = makeStyles((theme) => ({
  dialog: {
    backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .40),
    "& .MuiDialog-paper": {
      maxWidth: "1900px",
      margin: 0,
      [theme.breakpoints.down("mobile")]: {
        maxWidth: "340px",
      },
    },
    "& .MuiDialogActions-root": {
      display: "none",
    },
  },
  cross: {
    position: "absolute",
    top: "10px",
    right: "10px",
  },
  saveRangeSettingsWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10
  },
  saveRangeSettings: {
    padding: "10px 20px",
    fontSize: 14,
    minWidth: 150,
    boxShadow: "0px 4px 15px 0px rgba(166, 166, 166, 0.10)",
    borderRadius: 10,
    '&:hover': {
      backgroundColor: theme.palette.mainButton.darkBlue,
      color: theme.palette.mainButton.contrastText
    }
  },
  dialogContent: {
    padding: "20px",
    width: "700px",
    height: "auto",
    margin: 0,
    boxSizing: "border-box",
    [theme.breakpoints.down("mobile")]: {
      width: "340px",
      padding: "15px 10px",
    },
  },
  history: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "130%",
  },
  line: {
    background: theme.palette.secondary.light,
    width: "100%",
    height: "1px",
    margin: "8px 0 8px",
  },
  dataAndTimeContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    [theme.breakpoints.down("mobile")]: {
      gap: "4px",
    },
  },
  dataAndTimeInputs: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${theme.palette.secondary.main}`,
    padding: "8px",
    width: "100%",
    maxHeight: "32px",
    [theme.breakpoints.down("mobile")]: {
      maxHeight: "24px",
      padding: "3px 8px",
    },
  },
  lineY: {
    width: "1px",
    margin: "0 8px",
    height: "16px",
    background: theme.palette.secondary.main,
  },
}));

export default useStyles;
